export default "__VITE_ASSET__cYvKzYGI__"